'use strict';

/*
    In some cases we may require a functionality of passing some data to a grid that may not have been created yet.
    We will use this service to put the data, and once the grid gets loaded, it will pop it.
 */
var TransitionDataService = function TransitionDataService() {
  var transitionData = {};
  function put(gridId, data) {
    transitionData[gridId] = data;
  }
  function pop(gridId) {
    var data = transitionData[gridId];
    delete transitionData[gridId];
    return data;
  }
  function has(gridId) {
    return transitionData[gridId] !== undefined;
  }
  return {
    has: has,
    put: put,
    pop: pop
  };
};
TransitionDataService.$inject = [];
module.exports = TransitionDataService;